import { render, staticRenderFns } from "./KitManagement.vue?vue&type=template&id=f45a1e84"
import script from "./KitManagement.vue?vue&type=script&lang=js"
export * from "./KitManagement.vue?vue&type=script&lang=js"
import style0 from "./KitManagement.vue?vue&type=style&index=0&id=f45a1e84&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports